import { render, staticRenderFns } from "./attorney-index.vue?vue&type=template&id=5d0a4e90"
import script from "./attorney-index.vue?vue&type=script&lang=js"
export * from "./attorney-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports